import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import AddressFields from 'react/shared/components/true_link/lab/form/address_input/AddressFields';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import TrueLinkTooltip from 'react/shared/components/true_link/main/TrueLinkTooltip';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';
import theme from 'react/shared/theme/Theme';
import ErrorText from 'react/signups/card/common/ErrorText';
import businessDataShape from 'react/signups/card/shapes/BusinessData';

const useStyles = makeStyles(() => ({
  cardForPaidCaregiverRadios: {
    marginBottom: theme.spacing(4),
  },
}));

export default function BusinessForm({
  onChange,
  setValues,
  setFieldTouched,
  setFieldValue,
  values,
}) {
  const classes = useStyles();

  const handleRadioSelect = (event) => {
    setFieldValue('cardForPaidCaregiver', event.target.value);
  };

  const paidCaregiverAnswerOptions = [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'Maybe',
      value: 'maybe',
    },
    {
      label: 'No',
      value: 'no',
    },
  ];

  return (
    <>
      <CardText>
        We need a little more information about you before we help you order cards.
      </CardText>
      <TrueLinkTextInput
        labelText="Business name"
        name="name"
        onChange={onChange}
        placeholder="Business name"
        required
        setFieldTouched={setFieldTouched}
        value={values.name}
      />
      <AddressFields
        labelPrefix="Business"
        setFieldTouched={setFieldTouched}
        setValues={setValues}
        showPoBoxWarning
        values={values}
      />
      <TrueLinkTextInput
        labelText="How many clients do you have?"
        name="numberOfClients"
        onChange={onChange}
        placeholder="Number of clients"
        required
        setFieldTouched={setFieldTouched}
        value={`${values.numberOfClients}`}
      />
      <TrueLinkTextInput
        labelText="How many clients would you like to order cards for today?"
        name="numberOfInitialCards"
        onChange={onChange}
        placeholder="Number of cards"
        required
        setFieldTouched={setFieldTouched}
        value={`${values.numberOfInitialCards}`}
      />
      {values.numberOfInitialCards > 1 && values.numberOfInitialCards < 10 && (
        <CardText>
          Great, we’ll start with one, then you can order the rest of your cards on the dashboard.
        </CardText>
      )}
      {values.numberOfInitialCards >= 10 && (
        <CardText>
          You can order your first card now, or you can skip for now. Our customer support team can
          assist you in a bulk CSV upload.
        </CardText>
      )}
      <>
        <CardText>
          Will a paid caregiver be using the card to make purchases?{' '}
          <TrueLinkTooltip
            tooltipContent={
              <Typography>
                This is information we collect to better understand our customers, but will not
                impact your card order in any way.
              </Typography>
            }
          >
            <TrueLinkIcon className={classes.activityIcon} icon="circle-question fa-regular" />
          </TrueLinkTooltip>
        </CardText>
        <ErrorText name="cardForPaidCaregiver" />
        <div className={classes.cardForPaidCaregiverRadios}>
          <TrueLinkRadios
            ariaLabel="paid caregiver question"
            name="cardForPaidCaregiver"
            onChange={handleRadioSelect}
            options={paidCaregiverAnswerOptions}
            value={values.cardForPaidCaregiver}
          />
        </div>
      </>
    </>
  );
}

BusinessForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  values: businessDataShape.isRequired,
};
